
@if( bError ) {
	<div class="errorWarning">
		Beim Laden der Daten ist ein Fehler aufgetreten
	</div>
}
@else if( !myInputs.length ) {
	<div class="noResults">
		Diesem Mitglied sind keine Kategorien zugeordnet
	</div>
}
@else {

	<form [formGroup]="formG1">
	
		@for( myInput of myInputs; track myInput.id ) {
	
			<div style="display: flex; flex-flow: row wrap; gap: .5em; align-items: stretch;">
		
				<triv-input 
					[fGroup]="formG1" 
					[data]="myInput"
				/>
		
			</div>
	
		}
	
	</form>

}
